(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["new-faq-seo"] && !Shopify.designMode) return;
  try {
    
/* Keep aria-expanded in sync so the – appears when open */
document.addEventListener('DOMContentLoaded', function () {
  var root = document.getElementById('shopify-section-{{ section.id }}');
  if (!root) return;

  var accordion = root.querySelector('#faq-accordion-{{ section.id }}');
  if (!accordion) return;

  var triggers = accordion.querySelectorAll('h2.eeeeeee[data-toggle="collapse"][data-target]');
  triggers.forEach(function (h) {
    var sel = h.getAttribute('data-target');
    var panel = accordion.querySelector(sel);
    if (!panel) return;

    panel.addEventListener('shown.bs.collapse', function () {
      h.setAttribute('aria-expanded', 'true');
    });
    panel.addEventListener('hidden.bs.collapse', function () {
      h.setAttribute('aria-expanded', 'false');
    });

    h.addEventListener('click', function () {
      setTimeout(function () {
        h.setAttribute('aria-expanded', panel.classList.contains('show') ? 'true' : 'false');
      }, 0);
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
